import { map, isNil, defaultTo, view, isEmpty } from 'ramda'

export const viewDefault = (defaultValue) => (lens) =>
  defaultTo(defaultValue, view(lens))

export const getOrDefault = (defaultTo) => (getData) => {
  try {
    if (isNil(getData()) || isEmpty(getData())) return defaultTo
    else return getData()
  } catch (error) {
    return defaultTo
  }
}

//response must have data and total
export const panelParseResponse = (itemMapper) => (response) => {
  const getRemaingCount = () => response.meta.total - response.data.length
  return {
    items: map(itemMapper, response.data),
    remainingCount: getOrDefault(0)(getRemaingCount),
  }
}
